interface ContactAddress {
  id: string;
  city?: string | null;
  state?: string | null;
  is_primary?: boolean;
}

interface ProspectingValidationResult {
  isValid: boolean;
  missingFields: {
    contact: string[];
    deal: string[];
  };
  errorMessage: string;
}

export function validateProspectingRequirements(
  contact: any,
  deal: any,
  contactAddresses: ContactAddress[]
): ProspectingValidationResult {
  const missingContact: string[] = [];
  const missingDeal: string[] = [];
  
  // Contact validations
  if (!contact?.gender) missingContact.push('Gênero');
  if (!contact?.language) missingContact.push('Idioma');
  if (!contact?.contacts_source || contact.contacts_source === 'Unselected') {
    missingContact.push('Origem do Contato');
  }
  
  // Address validation (city AND state required)
  const primaryAddress = contactAddresses?.find(a => a.is_primary) || contactAddresses?.[0];
  if (!primaryAddress?.city || !primaryAddress?.state) {
    missingContact.push('Endereço (cidade e estado)');
  }
  
  // Deal validations
  if (!deal?.deals_source || deal.deals_source === 'Unselected') {
    missingDeal.push('Origem do Deal');
  }
  
  const isValid = missingContact.length === 0 && missingDeal.length === 0;
  
  let errorMessage = '';
  if (!isValid) {
    const parts: string[] = [];
    if (missingContact.length > 0) {
      parts.push(`Contato: ${missingContact.join(', ')}`);
    }
    if (missingDeal.length > 0) {
      parts.push(`Deal: ${missingDeal.join(', ')}`);
    }
    errorMessage = `Para avançar para Prospecting, preencha: ${parts.join(' | ')}`;
  }
  
  return { isValid, missingFields: { contact: missingContact, deal: missingDeal }, errorMessage };
}
